<!--
 * @FileDescription: 销货引导
 * @Author: ryb（作者）
 * @Date: 2020-04-13（时间）
 -->
<template>
  <div class="purchase-guidance-page">
    <a-tabs default-active-key="1" @change="callback">
      <a-tab-pane key="1" tab="场景一">
        <a-row class="guidance-step">
          <div class="guidance-step-right">
              <div class="step-box" @click="btnToGoPage(1)">
                <img src="@/assets/image/icon_cgrk.png" alt="" class="image">
                <span>采购入库</span>
              </div>
            <div class="point-to">
              <img src="@/assets/image/point_to.png" alt="">
            </div>
              <div class="step-box" @click="btnToGoPage(2)">
                <img src="@/assets/image/icon_sp.png" alt="" class="image">
                <span>审批</span>
              </div>
            <div class="point-to">
              <img src="@/assets/image/point_to.png" alt="">
            </div>
              <div class="step-box" @click="btnToGoPage(3)">
                <img src="@/assets/image/icon_gysfk.png" alt="" class="image">
                <span>向供应商付款</span>
              </div>
            <div class="point-to">
              <img src="@/assets/image/point_to.png" alt="">
            </div>
              <div class="step-box" @click="btnToGoPage(4)">
                <img src="@/assets/image/icon_fkd.png" alt="" class="image">
                <span>付款单</span>
              </div>
          </div>
        </a-row>
        <a-row class="guidance-explain">
          <div class="guidance-explain-title">
            <span>标准操作步骤：</span>
          </div>
          <div class="guidance-explain-row">
            <span class="row-text">1、根据您采购的需求和供应商明确，直接
                <span style="color: #F76F14; cursor: pointer;" @click="btnToGoPage(1)">创建一个采购入库单</span>
              ，录入商品，查看价格，进行交易。</span>
            <span class="row-text">2、支付款项，提交过账，提交后，可在单据中
                <span style="color: #F76F14; cursor: pointer;" @click="btnToGoPage(5)">已过账</span>
              可查看此单，并可在财务中
                <span style="color: #F76F14; cursor: pointer;" @click="btnToGoPage(3)">应收应付</span>
              查询过账情况</span>
            <span class="row-text">3、若此单有挂账后再给供应商的补充账单，则通过
                <span style="color: #F76F14; cursor: pointer;" @click="btnToGoPage(4)">创建一个付款单</span>
              来补充</span>
            <span class="row-text">4、如您支付了物流费用且没有在采购入库单中录入，则需要在财务中付款单中
                <span style="color: #F76F14; cursor: pointer;" @click="btnToGoPage(6)">创建一个其他支出单</span>
              ，并提交过账，可在单据中
                <span style="color: #F76F14; cursor: pointer;" @click="btnToGoPage(6)">其他支出单</span>
              可查看此单</span>
          </div>
        </a-row>
      </a-tab-pane>
      <a-tab-pane key="2" tab="场景二" force-render>
        <a-row class="guidance-step">
          <div class="guidance-step-left">
            <div class="guidance-step-left-one">
                <div class="step-box" @click="btnToGoPage(7)">
                  <img src="@/assets/image/icon_cgxh.png" alt="" class="image">
                  <span>采购询货</span>
                </div>
              <div class="point-to">
                <img src="@/assets/image/point_to.png" alt="">
              </div>
            </div>
            <div class="guidance-step-left-two">
                <div class="step-box" @click="btnToGoPage(8)">
                  <img src="@/assets/image/icon_cgdd.png" alt="" class="image">
                  <span>采购订单</span>
                </div>
              <div class="point-to">
                <img src="@/assets/image/point_to.png" alt="">
              </div>
            </div>
          </div>
          <div class="guidance-step-right">
              <div class="step-box" @click="btnToGoPage(1)">
                <img src="@/assets/image/icon_cgrk.png" alt="" class="image">
                <span>采购入库</span>
              </div>
            <div class="point-to">
              <img src="@/assets/image/point_to.png" alt="">
            </div>
              <div class="step-box" @click="btnToGoPage(2)">
                <img src="@/assets/image/icon_sp.png" alt="" class="image">
                <span>审批</span>
              </div>
            <div class="point-to">
              <img src="@/assets/image/point_to.png" alt="">
            </div>
              <div class="step-box" @click="btnToGoPage(3)">
                <img src="@/assets/image/icon_gysfk.png" alt="" class="image">
                <span>向供应商付款</span>
              </div>
            <div class="point-to">
              <img src="@/assets/image/point_to.png" alt="">
            </div>
              <div class="step-box" @click="btnToGoPage(4)">
                <img src="@/assets/image/icon_fkd.png" alt="" class="image">
                <span>付款单</span>
              </div>
          </div>
        </a-row>
        <a-row class="guidance-explain">
          <div class="guidance-explain-title">
            <span>标准操作步骤：</span>
          </div>
          <div class="guidance-explain-row">
            <span class="row-text">1、根据内部审核机制，进入
                <span style="color: #F76F14; cursor: pointer;" @click="btnToGoPage(9)">单据审核设置</span>
              中进行设置。</span>
            <span class="row-text">2、根据您采购的需求和供应商明确，直接
                <span style="color: #F76F14; cursor: pointer;" @click="btnToGoPage(1)">创建一个采购入库单</span>
              ，录入商品，查看价格，进行交易。</span>
            <span class="row-text">3、支付款项，提交过账，提交后，此单进入内部审核流程，在单据中的
                <span style="color: #F76F14; cursor: pointer;" @click="btnToGoPage(2)">待审核</span>
              进行查看和操作，被审核通过后，即完成过账。</span>
            <span class="row-text">4、完成过账的，可在单据中
                <span style="color: #F76F14; cursor: pointer;" @click="btnToGoPage(5)">已过账</span>
              可查看此单，并可在财务中
                <span style="color: #F76F14; cursor: pointer;" @click="btnToGoPage(3)">应收应付</span>
              查询过账情况。</span>
            <span class="row-text">5、若此单有挂账后再给供应商的补充账单，则通过
                <span style="color: #F76F14; cursor: pointer;" @click="btnToGoPage(4)">创建一个付款单</span>
              来补充。</span>
            <span class="row-text">6、如您支付了物流费用且没有在采购入库单中录入，则需要在财务中付款单中
                <span style="color: #F76F14; cursor: pointer;" @click="btnToGoPage(6)">创建一个其他支出单</span>
              ，并提交过账，可在单据中
                <span style="color: #F76F14; cursor: pointer;" @click="btnToGoPage(6)">其他支出单</span>
              可查看此单。</span>
          </div>
        </a-row>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
export default {
  name: 'purchaseGuidance',
  data () {
    return {

    }
  },
  mounted () {

  },
  methods: {
    callback (e) {

    },
    btnToGoPage(type) {
      /**   1    4     7   8
       * 1：采购入库单；2：审批；3：应收应付；4：付款单；5：已过账单据；6：其他支出单；7：采购询货；8：采购订单；9：单据审核设置
       */
      let url = null;
      if (type == 1) {
        if(this.$comm.has('purchase_guide_purchase_inbound')) {
          url = "/purchase/purchaseasmin/purchaseEnterWarehouse";
        } else {
          this.$message.warning("此按钮未被授权，请先去授权...")
        }
      } else if (type == 2) {
        if(this.$comm.has('guide_examine_approve')) {
          url = "/bill/billManage/Audits";
        } else {
          this.$message.warning("此按钮未被授权，请先去授权...")
        }
      } else if (type == 3) {
        if(this.$comm.has('guide_receipt_payment')) {
          url = "/finance/financedata/receiptPayment";
        } else {
          this.$message.warning("此按钮未被授权，请先去授权...")
        }
      } else if (type == 4) {
        if(this.$comm.has('guide_payment_order')) {
          url = "/finance/voucher/paymentOrder";
        } else {
          this.$message.warning("此按钮未被授权，请先去授权...")
        }
      } else if (type == 5) {
        if(this.$comm.has('guide_posted_documents')) {
          url = "/bill/billManage/postedDocuments";
        } else {
          this.$message.warning("此按钮未被授权，请先去授权...")
        }
      } else if (type == 6) {
        if(this.$comm.has('guide_other_expenses')) {
          url = "/finance/voucher/otherExpenses";
        } else {
          this.$message.warning("此按钮未被授权，请先去授权...")
        }
      } else if (type == 7) {
        if(this.$comm.has('purchase_guide_enquiry')) {
          url = "/purchase/purchaseasmin/enquiry";
        } else {
          this.$message.warning("此按钮未被授权，请先去授权...")
        }
      } else if ((type = 8)) {
        if(this.$comm.has('purchase_guide_purchase_order')) {
          url = "/purchase/purchaseasmin/purchaseOrder";
        } else {
          this.$message.warning("此按钮未被授权，请先去授权...")
        }
      } else if (type == 9) {
        if(this.$comm.has('guide_document_audit')) {
          url = "/system/set/documentAudit";
        } else {
          this.$message.warning("此按钮未被授权，请先去授权...")
        }
      }
      this.$router.push({ path: url })
    },
  }
}
</script>
<style lang="scss">
.purchase-guidance-page {
  height: calc(100vh - 170px);
  background-color: #ffffff;
  padding: 48px 84px;
  .ant-tabs-bar {
    border: 0;
  }
  .ant-tabs {
    height: 100%;
    .ant-tabs-tabpane {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
    }
  }
  .ant-tabs-nav-scroll {
    .ant-tabs-nav {
      .ant-tabs-tab {
        font-size: 24px;
        font-weight: bold;
        color: #919191;
        padding: 12px 0px;
        margin: 0 60px 0 0;
      }
      .ant-tabs-tab-active {
        color: #333333;
      }
    }
    .ant-tabs-ink-bar {
      height: 4px;
    }
  }
  .guidance-step {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 60px 0px 100px 120px;
    .step-box {
      width: 220px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .image {
        width: 80px;
        height: 80px;
      }
      span {
        font-size: 16px;
        padding-top: 12px;
      }
    }
    .guidance-step-left {
      .guidance-step-left-one,
      .guidance-step-left-two {
        display: flex;
        .point-to {
          margin-top: 30px;
        }
      }
      .guidance-step-left-two {
        margin-top: 60px;
      }
    }
    .guidance-step-right {
      display: flex;
      align-items: center;
      .point-to {
        height: 116px;
        padding-top: 30px;
      }
    }
  }
  .guidance-explain {
    color: #333333;
    .guidance-explain-title {
      font-size: 20px;
      font-weight: bold;
    }
    .guidance-explain-row {
      display: flex;
      flex-direction: column;
      .row-text {
        font-size: 16px;
        padding: 5px 0;
      }
    }
  }
}
</style>
